import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import './ViewToggle.scss'

class ViewToggle extends PureComponent {
  render () {
    const type = {LIST: 0, MAP: 1}
    return (
      <div className='sc-results-type visible-xs'>
        <div className='btn-group' role='group'>
          <button type='button'
            className={classnames('btn btn-left', { 'btn-active': this.props.type === type.LIST })}
            onClick={e => this.props.toggleViewType(type.LIST)}>
            List
          </button>
          <button type='button'
            className={classnames('btn btn-right', { 'btn-active': this.props.type === type.MAP })}
            onClick={e => this.props.toggleViewType(type.MAP)}>
            Map
          </button>
        </div>
      </div>
    )
  }
}

ViewToggle.propTypes = {
  type: PropTypes.number,
  toggleViewType: PropTypes.func
}

export default ViewToggle



// WEBPACK FOOTER //
// ./src/components/Results/ViewToggle/ViewToggle.jsx